import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IBackgroundJobParams, IExecution } from '../types/IExecution';

/**
 * The VizPortal `getExecutionStatus` Web Client method (CM `getJobStatus`): the current status of a
 * Content Mobility execution (extract / upload / import) for a background job id. Before the worker
 * links the job to the execution the monolith reports a synthetic QUEUED, so callers keep polling.
 */
export class GetExecutionStatusRequest extends Request<IBackgroundJobParams, IExecution> {
  constructor(params: IBackgroundJobParams) {
    super('getExecutionStatus', params);
  }
}
